import "./ThreeSection.css";

export const ThreeSection = () => {
  return <div className="parentDiv">Hello</div>;
};
